import React from 'react'
// libs
import { reduxForm } from 'redux-form'
// components
import { ReduxTimePicker } from 'components/FormElements/ReduxForm'
import Grid from '@mui/material/Grid2'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// themes
import { ActionsWrapper, Content } from 'themes/views/modals'
// constants
import { Forms } from 'constants/forms'
import { InjectedFormProps } from 'redux-form/lib/reduxForm'

interface Props {
  onCancelClick: () => void
}

const SetHoursForm: React.FC<InjectedFormProps<any, Props> & Props> = ({ handleSubmit, onCancelClick }) => (
  <form onSubmit={handleSubmit}>
    <Content>
      <Grid container spacing={5}>
        <Grid
          size={{
            lg: 6,
            md: 6
          }}>
          <ReduxTimePicker label='Start Time' name='startTime' />
        </Grid>
        <Grid
          size={{
            lg: 6,
            md: 6
          }}>
          <ReduxTimePicker label='Finish Time' name='finishTime' />
        </Grid>
      </Grid>
    </Content>
    <ActionsWrapper>
      <Grid container spacing={2}>
        <Grid>
          <Button layout={BUTTON_LAYOUTS.PURPLE} type='submit'>
            Save
          </Button>
        </Grid>
        <Grid>
          <Button layout={BUTTON_LAYOUTS.WHITE} onClick={onCancelClick}>
            Cancel
          </Button>
        </Grid>
      </Grid>
    </ActionsWrapper>
  </form>
)

export default reduxForm<any, Props>({
  form: Forms.SET_WORKING_HOURS_FORM,
  enableReinitialize: true
})(SetHoursForm)
